import React, { useContext, useEffect, useRef, useState } from "react";

import { PermisionDenied } from "../../../common/commonComponents";
import { PermissionContext, RolePermissions } from "appContext";
import { pages } from "../../../common/constant";

import BulkIssueFilters from "./Filters";
import MaterialDistributionTable from "./Table";
import { INITIAL_FILTER_STATE, searchStudentMaterial } from "./helper";
import moment from "moment";

const MaterialDistribution = () => {
  const permissions = useContext(PermissionContext);

  const userPermissions = RolePermissions(
    permissions,
    pages["materialDistribution"]["id"]
  );

  let scannedRows = useRef(0);
  let eligibleRowsForReversal = useRef(0);

  const [filters, setFilters] = useState({
    ...INITIAL_FILTER_STATE,
    searchBy: "",
    searchByValue: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const [selectionModel, setSelectionModel] = useState([]);

  useEffect(() => {
    if (filters.materialId?.length) searchStudentsForMaterials({});
  }, [filters, currentPage, pageSize]);

  const searchStudentsForMaterials = async ({
    payload = filters,
    offset = currentPage,
    limit = pageSize,
  }) => {
    setIsLoading(true);
    const response = await searchStudentMaterial({
      payload,
      offset,
      limit,
    });

    if (response?.code === 200) {
      const { totalRecords, responseDTO } = response.data;
      let reversibleRows = 0;
      let count = 0;

      const modifiedRows = responseDTO.map((item) => {
        if (!item.isEligibleForScan) count++;

        if (item.isEligibleForScan)
          return { ...item, isReversible: false, consentStatus: "Pending" };

        let isScannedWithinDay =
          moment().diff(moment(item?.consentDate), "hours") < 24 || false;

        if (permissions.roleType === "CR_STOCK_RCC_OWNED")
          isScannedWithinDay = true;

        const isAnyItemIssued = item?.status.toLowerCase() === "issued";

        if (!isAnyItemIssued && isScannedWithinDay) {
          reversibleRows++;
          return { ...item, isReversible: true, consentStatus: "Scanned" };
        }

        return {
          ...item,
          isReversible: false,
          consentStatus: isAnyItemIssued ? "Issued" : "Scanned",
        };
      });

      eligibleRowsForReversal.current = reversibleRows;
      scannedRows.current = count;
      setRowData(modifiedRows);
      setTotalRows(totalRecords);
    }

    setIsLoading(false);
  };

  const resetPage = () => {
    searchStudentsForMaterials({
      payload: { ...INITIAL_FILTER_STATE, searchBy: "", searchByValue: "" },
      currentPage: 0,
    });
  };

  return userPermissions.length ? (
    <div>
      <BulkIssueFilters
        filters={filters}
        setFilters={setFilters}
        isLoading={isLoading}
        resetPage={resetPage}
        permissions={permissions}
        selectionModel={selectionModel}
        setSelectionModel={setSelectionModel}
        rowData={rowData}
        eligibleRowsForReversal={eligibleRowsForReversal}
        searchStudentsForMaterials={searchStudentsForMaterials}
      />

      <MaterialDistributionTable
        rowData={rowData}
        pageSize={pageSize}
        setPageSize={setPageSize}
        totalRows={totalRows}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        filters={filters}
        setFilters={setFilters}
        searchStudentsForMaterials={searchStudentsForMaterials}
        scannedRows={scannedRows}
        selectionModel={selectionModel}
        setSelectionModel={setSelectionModel}
        permissions={permissions}
      />
    </div>
  ) : (
    <PermisionDenied />
  );
};

export default MaterialDistribution;
